import { Switch } from "antd";
import { ICellRendererParams } from "ag-grid-community";
import { updateProductMapping } from "@/ts/utils";
import { showToast } from "@/ts/modals";
import { TUpdateConfigBulkProductMapping } from "@/ts/common-types";

const PowerSkuCellRenderer = (params: ICellRendererParams) => {
    const handleToggle = async (checked: boolean) => {
        try {
            const updateConfig: TUpdateConfigBulkProductMapping = {
                sku_channel: [
                    {
                        channel: params.data.channel_id as number,
                        sku: params.data.sku as string | number,
                    },
                ],
                update_params: {
                    isPowerSku: checked,
                },
            };

            const response = await updateProductMapping(updateConfig);

            if (response.status) {
                params.api.getRowNode(params.node.id).setData({
                    ...params.data,
                    [params.colDef.field]: checked,
                });

                showToast(
                    "success",
                    `${params.data.sku} ${checked ? "set" : "removed"
                    } as Power SKU successfully`
                );
            }
        } catch (err: any) {
            showToast(
                "danger",
                `Failed to ${checked ? "set" : "removed"} ${params.data.sku
                } as Power SKU`
            );
        }
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <Switch checked={params.value} onChange={handleToggle} />
            )}
        </>
    );
};

export default PowerSkuCellRenderer;
